export default function ServicesFeature() {
  const services = [
    {
      icon: 'ri-home-wifi-line',
      title: 'Smart Home Integration',
      description: 'Complete automation solutions integrating lighting, climate, entertainment, and security into one seamless system.',
      features: ['Centralized control', 'Voice integration', 'Scene automation']
    },
    {
      icon: 'ri-router-line',
      title: 'Fiber Optic Installation',
      description: 'Enterprise-grade fiber optic cabling providing ultra-fast, reliable connectivity for modern smart homes.',
      features: ['10Gbps+ speeds', 'Future-proof infrastructure', 'Professional installation']
    },
    {
      icon: 'ri-camera-line',
      title: 'Security Camera Systems',
      description: 'Advanced surveillance solutions with 4K cameras, AI detection, and cloud storage for complete property protection.',
      features: ['4K resolution', 'AI motion detection', 'Remote monitoring']
    },
    {
      icon: 'ri-plug-line',
      title: 'Structured Cabling',
      description: 'Professional low-voltage wiring for data, audio, video, and control systems throughout your property.',
      features: ['Cat6A/Cat7 cabling', 'Clean installation', 'Certified technicians']
    },
    {
      icon: 'ri-speaker-line',
      title: 'Multi-Room Audio',
      description: 'Distributed audio systems delivering high-fidelity sound to every room with centralized control.',
      features: ['Whole-home audio', 'Streaming integration', 'Zone control']
    },
    {
      icon: 'ri-tv-line',
      title: 'Home Theater Design',
      description: 'Custom cinema experiences with premium displays, immersive audio, and automated lighting control.',
      features: ['4K/8K projection', 'Dolby Atmos', 'Acoustic treatment']
    }
  ];

  return (
    <section id="services" className="py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-[1400px] mx-auto px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-[11px] tracking-[0.3em] uppercase text-[#4A90E2] mb-4 font-light">
            OUR SERVICES
          </p>
          <h2 className="text-5xl font-serif text-gray-900 mb-6">
            <strong>Comprehensive Solutions</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            From initial design to final installation, we provide end-to-end <strong>smart home services</strong> for residential and commercial properties in <strong>Florida</strong>
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl p-8 border border-gray-200 hover:border-[#4A90E2]/30 hover:shadow-xl transition-all duration-300"
            >
              {/* Icon */}
              <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-[#4A90E2] to-[#357ABD] flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${service.icon} text-2xl text-white`}></i>
              </div>

              {/* Content */}
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {service.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-6">
                {service.description}
              </p>

              {/* Features */}
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center gap-2">
                    <div className="w-1.5 h-1.5 rounded-full bg-[#4A90E2]"></div>
                    <span className="text-sm text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <a
            href="#contact"
            className="inline-flex items-center gap-2 px-8 py-4 bg-[#4A90E2] text-white text-sm font-medium tracking-wide rounded-full hover:bg-[#3A7BC8] hover:shadow-lg hover:shadow-[#4A90E2]/30 transition-all cursor-pointer whitespace-nowrap"
          >
            Request a Quote
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
